import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useProdGroupDetail(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/product-groups/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProdGroupDetail;
